<template>
  <v-dialog
    @keydown.esc="closeModal"
    @click:outside="closeModal"
    v-bind="$props"
    v-model="dialog"
  >
    <v-card>
      <v-card-title>
        <slot name="title" />
        <v-spacer />
        <v-tooltip top>
          <template #activator="{ on }">
            <v-btn :id="`${parentName}_close`" icon @click="closeModal()" v-on="on">
              <v-icon>close</v-icon>
            </v-btn>
          </template>
          <span>{{ $tc('close') }} </span>
        </v-tooltip>
      </v-card-title>
      <slot name="prepend" />
      <v-card-text>
        <slot name="text" />
      </v-card-text>

      <v-card-actions v-if="$slots.actions" class="pa-4">
        <slot name="actions" />
      </v-card-actions>
      <slot name="append" />
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ModalContent',
  props: {
    open: {
      type: Boolean,
      required: true,
      default: false
    },
    maxWidth: {
      type: String,
      required: false,
      default: '600px'
    },
    persistent: {
      type: Boolean,
      required: false,
      default: false
    },
    parentName: {
      type: String,
      required: true
    },
    overlayOpacity: {
      type: Number,
      required: false,
      default: undefined
    }
  },
  data () {
    return {
      dialog: false
    }
  },
  computed: {
    // ERRORS
  },
  validations () {
    const validations = {}
    return validations
  },
  methods: {
    closeModal () {
      this.$emit('close')
    }
  },
  watch: {
    open (val) {
      this.dialog = val
    }
  }
}
</script>

<style>

</style>
